import React from 'react'

export default function Deleteiconsvg() {
    return <>
    <svg id="Component_3_1" data-name="Component 3 – 1" xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" viewBox="0 0 110 90">
        <rect id="Rectangle_26" data-name="Rectangle 26" width="110" height="90" rx="28" fill="rgba(255,0,0,0.52)"/>
        <path id="Icon_material-delete-sweep" data-name="Icon material-delete-sweep" d="M47.246,46.842H60.86v6.807H47.246Zm0-27.228H71.07v6.807H47.246Zm0,13.614H67.667v6.807H47.246ZM6.4,53.649a6.827,6.827,0,0,0,6.807,6.807H33.632a6.827,6.827,0,0,0,6.807-6.807V19.614H6.4ZM43.842,9.4H33.632L30.228,6H16.614l-3.4,3.4H3v6.807H43.842Z" transform="translate(18 12)" fill="#fff"/>
    </svg>
    </>
}